// loader.interceptor.ts
import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { ResolverLoaderService } from '../services/resolver-loader.service';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
    const skip = req.headers.get('X-Skip-Loader') === 'true';
    if (skip) return next(req);
  
    const loader = inject(ResolverLoaderService);
    const customMessage = req.headers.get('X-Loader-Message') || undefined;
  
    loader.beginHttp(customMessage);  // 👈 passa il messaggio opzionale
  
    return next(req).pipe(
      finalize(() => loader.endHttp())
    );
  };
